import { useMemo } from 'react';

import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { projectDetailsQueryOptions } from '@/app/queries/projects';
import { Button } from '@/common/components/elements/button';
import { Title } from '@/common/components/elements/title';
import { Can } from '@/common/components/features/role-management';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/common/components/modules/tabs';
import { InviteMembersManager } from '@/modules/members/components/invite-members-manager';
import { MemberList } from '@/modules/members/components/member-list';
import { RequestList } from '@/modules/members/components/request-list';
import { useGetProjectAccessListQuery } from '@/modules/members/queries/use-get-project-access-list-query';

const Members = () => {
  const { projeto: projectId } = Route.useParams();
  const { data: projectDetails } = useSuspenseQuery(projectDetailsQueryOptions(projectId));

  const { data: accessList, isLoading: isLoadingAccessList } =
    useGetProjectAccessListQuery(projectId);

  const members = useMemo(() => accessList?.members, [accessList?.members]);
  const requests = useMemo(() => accessList?.requests, [accessList?.requests]);

  return (
    <div className='flex flex-col w-full h-full gap-6'>
      <div className='flex flex-col gap-3'>
        <div className='flex flex-col sm:items-center sm:justify-between sm:flex-row'>
          <div className='flex flex-col gap-1'>
            <Title className='capitalize'>Membros</Title>
            <span className='text-content-neutral-primary text-xs'>Em {projectDetails.name}</span>
          </div>

          <Can I='create' a='Member'>
            <div className='items-center gap-2'>
              <InviteMembersManager projectId={projectId}>
                {({ open }) => (
                  <Button variant='primary' onClick={open} animated>
                    Convidar membros
                  </Button>
                )}
              </InviteMembersManager>
            </div>
          </Can>
        </div>

        <span className='flex items-center'>
          <span className='h-px flex-1 bg-border-neutral'></span>
        </span>
      </div>
      <div className='flex flex-col gap-3'>
        <Tabs defaultValue='members' className='w-full gap-6'>
          <TabsList>
            <TabsTrigger value='members'>Membros</TabsTrigger>
            <TabsTrigger value='requests' badge={requests?.length}>
              Solicitações
            </TabsTrigger>
          </TabsList>
          <TabsContent value='members'>
            <MemberList data={members} loading={isLoadingAccessList} projectId={projectId} />
          </TabsContent>
          <TabsContent value='requests'>
            <RequestList data={requests} loading={isLoadingAccessList} projectId={projectId} />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
};

export const Route = createFileRoute('/_app/_dashboard/projetos/$projeto/membros')({
  component: Members,
  loader: () => {
    return {
      crumb: 'Membros',
    };
  },
});
